module.exports = __webpack_public_path__ + "img/spot-2.0da0fa23.png";